<template>
  <CommonDrop
      ref="drop"
      v-model="currentValue"
      url="/trade/company/list"
      :autoDefault="autoDefault"
      :filterable="true"
      :remote="true"
      :size="size"
      :clearable="clearable"
      :disabled="disabled"
      :default-item="defaultItem"
  ></CommonDrop>
</template>
<script>
import CommonDrop from '@/components/CommonDrop'

export default {
  components: { CommonDrop },
  name: 'FactoryDrop',
  props: {
    value: {
      type: String | Number,
      default: null,
    },
    size: {
      type: String,
      default: 'mini'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autoDefault: {
      type: Boolean,
      default: false
    },
    defaultItem: {
      type: Object,
      default: () => {
        return {
          id: "",
          label: "请选择",
        };
      },
    },
  },
  computed: {
    currentValue: {
      get () {
        if (this.value === null || this.value === undefined) {
          return ''
        }
        return String(this.value)
      },
      set (newVal) {
        this.$emit('input', newVal)
        this.$emit('change', this.$refs.drop.dataList.find(e => e.id === newVal))
      },
    },
  },
  methods: {},
}
</script>
